module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/c1be915a20e877ebc5196d385393e5c8.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/expand.svg
// module id = IG3/
// module chunks = 1